import * as userActions from '../actions/user.actions';
import { User, WelcomeVoucher, UserPricedrop, UserWishes, UserFollows } from '@vestiaire/api-sdk-angular';
import { UserLikes } from '@vestiaire/api-sdk-angular';

export interface IUserState {
  authenticated: boolean;
  error?: any;
  loading: boolean;
  user?: User | null;
  likedItems?: UserLikes;
  priceDropFollow?: UserPricedrop;
  wallet?: any;
  welcomeVoucher?: WelcomeVoucher;
  wishedItems?: UserWishes;
  followingMember?: UserFollows;
  hasWallet?: boolean;
  isGuestUser?: boolean;
  modalType?: string;
}

const initialState: IUserState = {
  authenticated: false,
  loading: false,
  likedItems: {}
};
export interface PopinAuthState {
  type: 'login' | 'join' | 'registration' | 'password' | 'password-confirmation' | 'welcome';
  forced: boolean;
  isMobile?: boolean;
}

export function reducer(state: IUserState = initialState, action: userActions.All): IUserState {
  switch (action.type) {
    case userActions.AUTHENTICATED:
      return {
        ...state,
        ...{
          loading: true
        }
      };

    case userActions.AUTHENTICATED_FAILURE:
      return {
        ...state,
        ...{
          authenticated: false,
          loading: false
        }
      };

    case userActions.AUTHENTICATED_SUCCESS:
      return {
        ...state,
        ...{
          authenticated: action.payload.authenticated,
          loading: false,
          error: null,
          user: action.payload.user,
          isGuestUser: false
        }
      };

    case userActions.SET_USER_LIKED_ITEMS:
      return {
        ...state,
        ...{
          likedItems: action.payload
        }
      };

    case userActions.SET_USER_PRICE_DROP_FOLLOW_ITEMS:
      return {
        ...state,
        ...{
          priceDropFollow: action.payload
        }
      };

    case userActions.ADD_USER_PRICE_DROP_FOLLOW_ITEMS:
      return {
        ...state,
        ...{
          priceDropFollow: action.payload
        }
      };

    case userActions.REMOVE_USER_PRICE_DROP_FOLLOW_ITEMS:
      return {
        ...state,
        ...{
          priceDropFollow: action.payload
        }
      };

    case userActions.SET_USER_WISHED_ITEMS:
      return {
        ...state,
        ...{
          wishedItems: action.payload
        }
      };

    case userActions.ADD_USER_WISHED_ITEMS:
      return {
        ...state,
        ...{
          wishedItems: action.payload
        }
      };

    case userActions.REMOVE_USER_WISHED_ITEMS:
      return {
        ...state,
        ...{
          wishedItems: action.payload
        }
      };

    case userActions.GET_USER_WALLET:
      return {
        ...state,
        ...{
          wallet: action.payload
        }
      };

    case userActions.LOGIN:
    case userActions.REGISTER:
      return {
        ...state,
        ...{
          authenticated: false,
          error: undefined,
          loading: true
        }
      };

    case userActions.LOGIN_FAILURE:
      return {
        ...state,
        ...{
          authenticated: false,
          error: action.payload.error,
          loading: false
        }
      };

    case userActions.REGISTER_FAILURE:
      return {
        ...state,
        ...{
          authenticated: false,
          error: action.payload,
          loading: false
        }
      };

    case userActions.REGISTER_SUCCESS:
    case userActions.LOGIN_SUCCESS:
      return {
        ...state,
        ...{
          authenticated: true,
          error: undefined,
          loading: false,
          user: action.payload.session.user
        }
      };

    case userActions.LOGOUT_FAILURE:
      return {
        ...state,
        ...{
          authenticated: false,
          error: action.payload,
          user: null,
          wallet: null
        }
      };

    case userActions.LOGOUT_SUCCESS:
      return {
        ...initialState,
        ...{
          authenticated: false,
          error: undefined,
          user: null,
          loading: false,
          wallet: undefined,
          isGuestUser: state.isGuestUser
        }
      };

    case userActions.RESET_STATE:
      return initialState;

    case userActions.GET_WELCOME_VOUCHER_SUCCESS:
      return {
        ...state,
        ...{
          welcomeVoucher: action.payload
        }
      };

    case userActions.SET_USER_FOLLOW_MEMBER:
      return {
        ...state,
        ...{
          followingMember: action.payload
        }
      };

    case userActions.ADD_USER_FOLLOW_MEMBER:
      return {
        ...state,
        ...{
          followingMember: action.payload
        }
      };

    case userActions.REMOVE_USER_FOLLOW_MEMBER:
      return {
        ...state,
        ...{
          followingMember: action.payload
        }
      };

    case userActions.CONTINUE_AS_GUEST:
      return {
        ...state,
        ...{
          isGuestUser: action.payload
        }
      };

    case userActions.POPIN_AUTH_SHOWED:
      return {
        ...state,
        ...{
          modalType: action.payload.type
        }
      };

    default:
      return state;
  }
}

export const isAuthenticated = (state: IUserState) => state.authenticated;
export const isLoading = (state: IUserState) => state.loading;

export const getError = (state: IUserState) => state.error;
export const getPending = (state: IUserState) => state.loading;

export const getUser = (state: IUserState) => state.user;
export const getUserEmail = (state: IUserState) => state.user && state.user.email;
export const getLikedItems = (state: IUserState) => state.likedItems;
export const getWelcomeVoucher = (state: IUserState) => state.welcomeVoucher;
export const getPriceDropFollowItems = (state: IUserState) => state.priceDropFollow;
export const getFollowingMembers = (state: IUserState) => state.followingMember;
export const getWishedItems = (state: IUserState) => state.wishedItems;
export const getWallet = (state: IUserState) => state.wallet;
export const getHasWallet = (state: IUserState) => state.hasWallet;
export const isGuestUser = (state: IUserState) => state.isGuestUser;
export const getAuthModalType = (state: IUserState) => state.modalType;
